import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

export const NoInstantAnswerSection: React.FC = () => {
  return (
    <Column>
      <Typography variant="sectionHeaderSansMedium">
        <StrictLocalMsg defaultMessage="Let’s find answers to resolve your issue" />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg defaultMessage="For a faster answer, check out the related articles listed below. Still have questions? Contact us for more help." />
      </Typography>
      <Spacer height="5x" />
    </Column>
  );
};
